module.exports = __webpack_public_path__ + "237997f00a34c0271098a56c5abb713f.svg";